import { useQuery } from '@tanstack/react-query'

import type { Platform } from '../../types/platforms'
import api from '../../api'

const useSinglePlatform = (platformID: string) => {
	return useQuery({
		queryKey: ['platforms', platformID],
		queryFn: () => api.platforms.getSinglePlatform(platformID, true),
		select(data) {
			if (data.body !== undefined) {
				const response = sortComments(data.body[0])
				return response as Platform
			} else {
				let response = {} as Platform
				response['status'] = 'ERROR'
				response['details'] = data
				return response
			}
		}
	})
}
const sortComments = (response: Record<any, any>) => {
	let sortedCommentResponse = JSON.parse(JSON.stringify(response))
	let comments = (response && response.comments) || []
	sortedCommentResponse['comments'] = comments.sort(
		(a: any, b: any) =>
			new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
	)
	return sortedCommentResponse
}

export default useSinglePlatform
